import { Dispatch, SetStateAction } from "react";
import ScalingDateRangePicker, {
  ScalingDateRangePickerProps,
} from "../../ScalingDateRangePicker";
import { TimeRange } from "../../SearchBar/SearchProvider";
import { FormatDateRange } from "./DateRangeSearch";
import SearchCard, { SearchCardProps } from "./SearchCard";
import TimeRangePicker from "./TimeRangePicker";

type DateRangeSearchCardProps = Omit<SearchCardProps, "label"> & {
  from: Date | null;
  setFrom: Dispatch<SetStateAction<Date | null>>;
  until: Date | null;
  setUntil: Dispatch<SetStateAction<Date | null>>;
} & (
    | {
        timeRanges: TimeRange[];
        setTimeRanges: Dispatch<SetStateAction<TimeRange[]>>;
      }
    | {
        timeRanges?: undefined;
        setTimeRanges?: undefined;
      }
  ) &
  Pick<ScalingDateRangePickerProps, "maxRange">;

export default function DateRangeSearchCard({
  from,
  setFrom,
  until,
  setUntil,
  maxRange,
  timeRanges,
  setTimeRanges,
  ...searchCardProps
}: DateRangeSearchCardProps) {
  return (
    <SearchCard
      {...searchCardProps}
      label={FormatDateRange({ from, until, timeRanges })}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {setTimeRanges && (
          <TimeRangePicker
            timeRanges={timeRanges}
            setTimeRanges={setTimeRanges}
          />
        )}
        <ScalingDateRangePicker
          numCalenders={{
            max: 2,
          }}
          from={from}
          setFrom={setFrom}
          until={until}
          setUntil={setUntil}
          maxRange={maxRange}
        />
      </div>
    </SearchCard>
  );
}
